/**
 * Entry Point
 * VROONG 애플리케이션 진입점
 */
import React from "react";
import ReactDOM from 'react-dom/client';
import App from './app/App';
import './styles/vroong-design-system.css';
import './styles/layout.css';
import './styles/global.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <App />
);
